<template>
  <UiModal name="signup">
    <form class="flex flex-col space-y-6">
      <h3 class="text-3xl text-center font-extrabold" v-text="t('header')" />
      <fieldset class="flex flex-col space-y-4">
        <div class="flex items-center">
          <input ref="nickname" class="py-2 px-3 w-full rounded" type="text" v-model="data.nickname" :placeholder="t('nickname')" required :disabled="success" />
        </div>
        <div class="flex items-center">
          <input class="py-2 px-3 w-full rounded" type="text" v-model="data.country" :placeholder="t('country')" required :disabled="success" />
          <span class="inline-block -ml-8" />
        </div>
        <div class="flex items-center">
          <input class="py-2 px-3 w-full rounded" type="text" v-model="data.account" :placeholder="t('id')" required :disabled="success" />
          <!-- <a
            class="inline-block -ml-8"
            href="https://www.epicgames.com/help/epic-accounts-c74/general-support-c79/what-is-an-epic-account-id-and-where-can-i-find-it-a3659"
            target="_blank"
            ><i class="fa fa-question-circle"
          /></a> -->
        </div>
        <div class="flex items-center">
          <input class="py-2 px-3 w-full rounded" type="text" v-model="data.contacts" :placeholder="t('contacts')" :disabled="success" />
        </div>
      </fieldset>
      <div class="flex flex-col space-y-4 md:flex-row md:space-x-8 md:space-y-0">
        <label class="flex flex-1 items-center cursor-pointer"> <input class="h-6 w-6" v-model="data.day1" type="checkbox" :disabled="success" />&nbsp;{{ t('duels') }} </label>
        <label class="flex flex-1 items-center cursor-pointer"> <input class="h-6 w-6" v-model="data.day2" type="checkbox" :disabled="success" />&nbsp;{{ t('draft') }} </label>
      </div>
      <UiButton class="bg-gradient-to-br from-orange-500 to-red-700 hover:from-yellow-500" v-text="t(error ? 'sendAgain' : 'send')" v-if="!success" @click="apply()" />
      <UiButton color="green" v-text="t('sended')" v-if="success" />
      <div class="p-2 text-center text-base text-red" v-if="error">{{ t('error') }} {{ error }}</div>
    </form>
    <i class="fa fa-times absolute top-0 right-0 m-3 p-1 cursor-pointer text-2xl text-gray-500 hover:text-red-600" @click="modals.signup = false" />
  </UiModal>
</template>

<script>
  import { ref, reactive, watchEffect, nextTick } from 'vue'
  import { modals } from '../store.js'
  import { useI18n } from 'vue-i18n'

  modals.signup = false

  export default {
    name: 'SignupModal',
    setup() {
      const nickname = ref(null)

      const data = reactive({
        country: '',
        nickname: '',
        account: '',
        contacts: '',
        day1: true,
        day2: true,
      })

      let success = ref(false)
      let error = ref(false)

      function apply() {
        success.value = false
        error.value = false
        window.alert('Signup is closed')
        // fetch('signup', {
        //   method: 'POST',
        //   body: JSON.stringify(data),
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        // }).then(res => {
        //   if (res.status === 200) {
        //     success.value = true
        //   } else {
        //     error.value = res.statusText
        //   }
        // })
      }

      watchEffect(() => {
        if (modals.signup) {
          nextTick(() => {
            nickname.value.focus()
          })
        }
      })

      const { t } = useI18n({
        messages: {
          en: {
            header: 'Application',
            nickname: 'Nick',
            country: 'Country',
            id: 'Epic display name',
            contacts: 'Contacts (for admins)',
            duels: 'Duels on day 1',
            draft: 'Draft on day 2',
            send: 'Send',
            sendAgain: 'Send again',
            sended: 'Sended',
            error: 'Error!',
          },
          ru: {
            header: 'Заявка',
            nickname: 'Ник',
            country: 'Страна',
            id: 'Имя Epic аккаунта',
            contacts: 'Контакты (для админов)',
            duels: 'Дуэли в день 1',
            draft: 'Драфт в день 2',
            send: 'Отправить',
            sendAgain: 'Снова отправить',
            sended: 'Отправлено',
            error: 'Ошибка!',
          },
        },
      })

      return {
        data,
        modals,
        success,
        error,
        apply,
        nickname,
        t,
      }
    },
  }
</script>
